import { apiSlice } from '../api/apiSlice'

export const userHistorySlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    userHistory: builder.mutation({
      query: () => ({
        url: 'game/history?language=en',
        method: 'GET',
      }),
    }),
  }),
})

export const userAddGameSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    userAddGames: builder.mutation({
      query: (game) => ({
        url: `game/favorite?language=en`,
        method: 'POST',
        body: game,
      }),
    }),
  }),
})

export const userAllCategorySlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    userAllCategory: builder.mutation({
      query: (data) => {
        const newPage = data.page ?? 1
        const category = data.categoryId
        return {
          url: `game/category/${category}?p=${newPage}&platform=B2BW&language=en&multiplayer=false&access_token=${data.access_token}`,
          method: 'GET',
        }
      },
    }),
  }),
})

export const userAllCategoryIdSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    userAllCategoryId: builder.mutation({
      query: ({access_token}) => {
        return {
          url: `game/category/viewall?platform=B2BW&language=en&access_token=${access_token}`,
          method: 'GET',
        }
      },
    }),
  }),
})

export const userDeleteGameSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    userDeleteGames: builder.mutation({
      query: (game) => {
        return {
          url: 'game/favorite?language=en',
          method: 'DELETE',
          body: game,
        }
      },
    }),
  }),
})

export const userRecordHistorySlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    userRecordHistory: builder.mutation({
      query: (id, options) => {
        return {
          url: `/game/${id}/history?language=en`,
          method: 'POST',
        }
      },
    }),
  }),
})

export const userNameSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    userName: builder.mutation({
      query: () => ({
        url: '/user/profile',
        method: 'GET',
      }),
    }),
  }),
})

export const userContinuePlaySlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    userContinuePlay: builder.mutation({
      query: (page) => {
        const pg = page ?? 1
        return {
          url: `/game/history/recentlyplayed?platform=B2BW&language=en&p=${pg}`,
          method: 'GET',
        }
      },
    }),
  }),
})

export const userSavedGamesSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    userSavedGames: builder.mutation({
      query: (page) => {
        const pg = page ?? 1
        return {
          url: `game/favorite?language=en&p=${pg}`,
          method: 'GET',
        }
      },
    }),
  }),
})

export const userReelRecomendationSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    userReelRecomendation: builder.mutation({
      query: (page) => {
        const pg = page ?? 1
        return {
          url: `/game/recommendation?language=en&platform=B2BW&p=${pg}`,
          method: 'GET',
        }
      },
    }),
  }),
})

export const userBulkUpdateSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    userBulkUpdate: builder.mutation({
      query: (games) => ({
        url: `game/favorite/bulkupdate`,
        method: 'POST',
        body: {
          games: games,
        },
      }),
    }),
  }),
})

export const { useUserRecordHistoryMutation } = userRecordHistorySlice

export const { useUserSavedGamesMutation } = userSavedGamesSlice

export const { useUserHistoryMutation } = userHistorySlice

export const { useUserNameMutation } = userNameSlice

export const { useUserContinuePlayMutation } = userContinuePlaySlice

export const { useUserReelRecomendationMutation } = userReelRecomendationSlice

export const { useUserDeleteGamesMutation } = userDeleteGameSlice

export const { useUserAddGamesMutation } = userAddGameSlice

export const { useUserBulkUpdateMutation } = userBulkUpdateSlice

export const { useUserAllCategoryMutation } = userAllCategorySlice

export const { useUserAllCategoryIdMutation } = userAllCategoryIdSlice
